<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('translation.difference') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="form">
					<div class="row">
						<div class="col-sm-12">
							<div class="form-body">
								<div id="messages" class="wrapped-box">
									<div>
										{{ $t('localization.messages') }}:
										<span class="float: right">
											<a><i class="glyphicon glyphicon-download-alt icon-th"
												  @click="downloadTranslation('MESSAGES')"></i></a>
											<a><i class="glyphicon glyphicon-cloud-upload icon-th"
												  @click="uploadTranslation('MESSAGES')"></i></a>
										</span>
									</div>
									<div v-for="(info, key) in translationDifference.messages" :key="key">
										{{info.language.toUpperCase()}}:
                                        <span v-if="info.count > 0" class="float: right">
                                            {{ $t('localization.not.localized.count', [info.count]) }}
                                        </span>
									</div>
								</div>

								<div id="items" class="wrapped-box">
									<div>
										{{ $t('localization.items') }}:
										<span class="float: right">
											<a><i class="glyphicon glyphicon-download-alt icon-th"
												  @click="downloadTranslation('ITEMS')"></i></a>
											<a><i class="glyphicon glyphicon-cloud-upload icon-th"
												  @click="uploadTranslation('ITEMS')"></i></a>
										</span>
									</div>
									<div v-for="(info, key) in translationDifference.items" :key="key">
										{{info.language.toUpperCase()}}:
										<span v-if="info.count > 0" class="float: right">
                                            {{ $t('localization.not.localized.count', [info.count]) }}
                                        </span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { TRANSLATED_DIFFERENCE } from 'actions/localization'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'

export default {
	name: 'Translation',
	metaInfo () {
		return {
			title: this.$t('translation.difference')
		}
	},
	data () {
		return {
			translationDifference: {}
		}
	},
	methods: {
		getTranslatedDifference: function () {
			this.$store.dispatch(TRANSLATED_DIFFERENCE)
			.then(() => {
				this.translationDifference = this.$store.getters.getTranslationDifference
			})
		},
		downloadTranslation: function (translationType) {
			downloadManager('/translation?resource=' + translationType)
		},
		uploadTranslation: function (translationType) {
			let vm = this
			Swal.fire({
				title: getLocalizedMessage('localization.messages.upload.title'),
				input: 'file',
				inputAttributes: {
					accept: '.json',
					'aria-label': getLocalizedMessage('localization.messages.upload.file')
				},
				confirmButtonText: getLocalizedMessage('upload'),
				showCancelButton: true,
				cancelButtonText: getLocalizedMessage('cancel'),
				buttonsStyling: false,
				showClass: {
					popup: ''
				},
				hideClass: {
					popup: ''
				},
				customClass: {
					content: 'upload-file',
					confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
					cancelButton: 'uk-button uk-button-default uk-button-small',
				}
			}).then(function (result) {
				if (result.value) {
					var file = result.value
					var data = new FormData()
					data.append('source', file)

					var url = window.urlContext + 'translation?resource=' + translationType

					$.ajax({
						url: url,
						data: data,
						cache: false,
						contentType: false,
						processData: false,
						type: 'POST',
						async: false,

						success: function () {
							showMessageAlert(getLocalizedMessage('success'), 'success')
						},
						error: function () {
							showMessageAlert(getLocalizedMessage('error'), 'danger')
						}
					})
				}
			})
		}
	},
	mounted () {
		this.getTranslatedDifference()
	}
}
</script>

<style scoped>

</style>
